
import React from 'react'
import { CheckCircle, Clock, AlertTriangle, X, RefreshCw } from 'lucide-react'
import { StatusType } from '@/lib/types'

interface StatusIndicatorProps {
  status: StatusType
  label?: string
  className?: string
}

export function StatusIndicator({ status, label, className = '' }: StatusIndicatorProps) {
  const statusConfig = {
    healthy: {
      icon: CheckCircle,
      color: 'text-greenish-cyan',
      bgColor: 'bg-greenish-cyan/10'
    },
    warning: {
      icon: AlertTriangle,
      color: 'text-reddish-orange',
      bgColor: 'bg-reddish-orange/10'
    },
    critical: {
      icon: X,
      color: 'text-reddish-orange',
      bgColor: 'bg-reddish-orange/10'
    },
    synced: {
      icon: CheckCircle,
      color: 'text-greenish-cyan',
      bgColor: 'bg-greenish-cyan/10'
    },
    pending: {
      icon: Clock,
      color: 'text-blue-koi',
      bgColor: 'bg-blue-koi/10'
    }
  }

  const config = statusConfig[status]
  const IconComponent = config.icon

  return (
    <div className={`inline-flex items-center gap-2 px-2 py-1 rounded-md ${config.bgColor} ${className}`}>
      <IconComponent className={`w-4 h-4 ${config.color}`} />
      {label && <span className={`text-xs font-medium ${config.color}`}>{label}</span>}
    </div>
  )
}
